import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const BicycleFront = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M11.4376 7.83975C12.2589 7.29219 13.224 7 14.2111 7L17.7889 7C18.776 7 19.741 7.29219 20.5624 7.83975L22.5547 9.16795C23.0142 9.4743 23.1384 10.0952 22.832 10.5547C22.5257 11.0142 21.9048 11.1384 21.4453 10.8321L19.453 9.50385C18.9602 9.17531 18.3812 9 17.7889 9L14.2111 9C13.6188 9 13.0398 9.17531 12.547 9.50385L10.5547 10.8321C10.0952 11.1384 9.47429 11.0142 9.16793 10.5547C8.86158 10.0952 8.98576 9.4743 9.44528 9.16795L11.4376 7.83975ZM16 9C16.5523 9 17 9.44772 17 10V12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12V10C15 9.44772 15.4477 9 16 9ZM12 18.1623C12 16.4406 13.1017 14.912 14.7351 14.3675C15.5561 14.0939 16.4438 14.0939 17.2649 14.3675C18.8983 14.912 20 16.4406 20 18.1623V24C20 24.5523 19.5523 25 19 25C18.4477 25 18 24.5523 18 24V18.1623C18 17.3014 17.4491 16.5371 16.6324 16.2649C16.2219 16.1281 15.7781 16.1281 15.3675 16.2649C14.5508 16.5371 14 17.3014 14 18.1623V24C14 24.5523 13.5523 25 13 25C12.4477 25 12 24.5523 12 24V18.1623ZM16 17C16.5523 17 17 17.4477 17 18V29C17 29.5523 16.5523 30 16 30C15.4477 30 15 29.5523 15 29V18C15 17.4477 15.4477 17 16 17Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default BicycleFront;
